// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2MW75","header":"MessagesList_header__2GgH0","chat":"MessagesList_chat__24xRq"};